import React, { Fragment } from 'react';
import { Button, Icon, Table, Header, Segment, Popup, Loader, Form, Grid } from 'semantic-ui-react';
import axios from 'axios';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';

import { IconHeader, FiltersOnStyle, HeaderCursor } from '../ProfessorInputGrades/css';
import CourseFilter from './CourseFilter';
import { fetchAcademicYears, fetchCurrentAcademicYear } from '../../Lookups/util';
import SearchTableData from '../../util/SearchTableData';
import PaginationFront from '../../util/PaginationFront';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const PreviousNoGradesFilterMessage = () => <p><FormattedMessage id="professorInputGrades.PreviousNoGradesFilterMessage" /></p>;
const NoDataMessage = () => <p><FormattedMessage id="professorInputGrades.NofinalizedExamsMessage" /></p>;


export default class ProfessorHistoryGrades extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            filterData: [],
            professorId: '',
            academicYears: [],
            academicYearId: '',

            showFiltersOnButton: false,
            showFilterMode: false,
            loading: true,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: []
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);

        this.handleInputChange = this.handleInputChange.bind(this);
        this.getGradedActivities = this.getGradedActivities.bind(this);
    }

    componentDidMount() {
        axios.all([fetchAcademicYears(), fetchCurrentAcademicYear()])
            .then(axios.spread((res, resCurrent) => {
                const academicYears = res.data.reverse().map((el, index) => ({
                    ...el,
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ academicYears });

                if (!localStorage.getItem('academicYearId')) {
                    this.setState({ academicYearId: resCurrent.data.id });
                    localStorage.setItem('academicYearId', resCurrent.data.id);
                    this.getGradedActivities();
                } else {
                    this.setState({ academicYearId: parseInt(localStorage.getItem('academicYearId'), 10) });
                    this.getGradedActivities();
                }
            }))
            .catch(err => {
                console.log('Failed to fetch academic years');
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    handleInputChange(event, { name, value }) {
        this.setState({ loading: true, results: [] });
        this.setState({
            [name]: value
        });
        localStorage.setItem('academicYearId', value);
        this.getGradedActivities();
    }

    getGradedActivities() {
        let obj = { academicYearId: parseInt(localStorage.getItem('academicYearId'), 10) };

        axios.post(`/professor/graded-activities/true/${window.$locale}`, { ...obj })
            .then(res => {
                const data = res.data.map(el => ({
                    ...el,
                    date: moment(el.gradedActivityDate).format('D. M. YYYY.')
                }));
                this.setState({ data, loading: false });
            })
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch courses');
            });
    }


    render() {
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                <Header as="h1"><FormattedMessage id="professorInputGrades.finalizedCourse" /></Header>


                <Segment.Group raised >
                    <Segment clearing>
                        <Header as="h3">
                            <FormattedMessage id="professorInputGrades.finalizedCourseList" />
                        </Header>
                    </Segment>

                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label><FormattedMessage id="common.academicYear" /></label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder={<FormattedMessage id="professorInputGrades.selectAcademicYear" />}
                                        value={this.state.academicYearId}
                                        onChange={this.handleInputChange}
                                        name="academicYearId"
                                        options={this.state.academicYears}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field />
                            </Form.Group>
                        </Form>
                        {/* </Segment> */}

                        {this.state.loading ? <Fragment><div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div></Fragment> :
                        <div>
                                {currentPosts.length ?
                                <Table celled selectable compact>
                                        <Table.Header>
                                        <Table.Row>
                                                <Table.HeaderCell colSpan={12} >
                                                <Grid stackable>
                                                        <Grid.Column>
                                                        <SearchTableData profMozilla data={this.getDataToRender()} getResults={this.getResults} filterItem={['courseImplementationName', 'gradedActivityName']} />
                                                    </Grid.Column>
                                                    </Grid>
                                            </Table.HeaderCell>
                                            </Table.Row>
                                        <Table.Row>
                                                <Table.HeaderCell colSpan="1">
                                                <FormattedMessage id="common.ordinal" />
                                            </Table.HeaderCell>
                                                <Table.HeaderCell colSpan="3">
                                                <FormattedMessage id="common.courseName" />
                                            </Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2">
                                                <FormattedMessage id="professorInputGrades.examType" />
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        <FormattedMessage id="professorInputGrades.methodName" />
                                                    </div>
                                            </Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2">
                                                <FormattedMessage id="professorInputGrades.examOnlyDate" />
                                            </Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2">
                                                <FormattedMessage id="professorInputGrades.finalizationCancelDate" />
                                            </Table.HeaderCell>
                                                <Table.HeaderCell colSpan="2" />
                                            </Table.Row>
                                    </Table.Header>
                                        <Table.Body> {currentPosts.map((el, index) =>
                                            (<Table.Row key={index}>
                                                <Table.Cell colSpan="1" verticalAlign="middle">
                                                    {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan="3">
                                                    <Grid columns={1} centered className="stackable">
                                                        <Grid.Row verticalAlign="middle">
                                                            <Grid.Column width="10">
                                                                {el.courseImplementationName}
                                                            </Grid.Column>
                                                            <Grid.Column width="6" verticalAlign="middle" textAlign="right">
                                                                <span style={{ color: '#a6a4a1' }}>{el.courseComment}</span>
                                                            </Grid.Column>
                                                        </Grid.Row>
                                                    </Grid>
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan="2">
                                                    {el.gradedActivityName}
                                                    <div style={{
                                                        fontSize: '0.85em',
                                                        color: '#999'
                                                    }}>
                                                        {el.gradingMethodName ? el.gradingMethodName : ''}
                                                    </div>
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan="2">
                                                    {el.date}
                                                </Table.Cell>
                                                <Table.Cell verticalAlign="middle" colSpan="2">
                                                    {el.finalizationCancelDate ? moment(el.finalizationCancelDate).format('D. M. YYYY.') + '\n' : ''}
                                                    {el.documentNumber ? ' ( Odluka: ' + el.documentNumber + ')' : ''}
                                                </Table.Cell>
                                                <Table.Cell textAlign="center" verticalAlign="middle" colSpan="2">
                                                    <FormattedMessage id="route.studentGrades">
                                                        {(msg) => (<Link to={{
                                                            pathname: msg,
                                                            state: {
                                                                courseImplementationId: el.courseImplementationId,
                                                                gradedActivityId: el.gradedActivityId,
                                                                gradedActivityName: el.gradedActivityName,
                                                                courseImplementationName: el.courseImplementationName,
                                                                date: el.date
                                                            }
                                                        }}
                                                        >
                                                            <Popup
                                                                content={<FormattedMessage id="professorInputGrades.showStudents" />}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        basic="true"
                                                                        circular
                                                                        icon="group"
                                                                        size="small"
                                                                        color="blue"
                                                                    >
                                                                    </Button>
                                                                }
                                                            />
                                                        </Link>)}</FormattedMessage>

                                                    <FormattedMessage id="route.examStatistic">
                                                        {(msg) => (<Link to={{
                                                            pathname: msg,
                                                            state: {
                                                                gradedActivityId: el.gradedActivityId,
                                                                gradedActivityName: el.gradedActivityName,
                                                                courseImplementationName: el.courseImplementationName,
                                                                date: el.date
                                                            }
                                                        }}
                                                        >
                                                            <Popup
                                                                content={<FormattedMessage id="statistics.statistic" />}
                                                                position="top center"
                                                                trigger={
                                                                    <Button
                                                                        basic="true"
                                                                        circular
                                                                        icon="chart bar"
                                                                        size="small"
                                                                        color="teal"
                                                                    >
                                                                    </Button>
                                                                }
                                                            />

                                                        </Link>)}</FormattedMessage>
                                                </Table.Cell>

                                            </Table.Row>))}
                                    </Table.Body>
                                    </Table>
                                    : <NoDataMessage />

                                }
                            {currentPosts.length >0 && <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />}
                        </div>

                        }
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorHistoryGrades/ProfessorHistoryGrades.js